export default __webpack_public_path__ + "static/media/img-default.077157b5.svg";